import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/categories';

export default function ArticlesGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-6 mb-12">
          <div className="lg:w-[33%]">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              Poradniki
            </h2>
            <p className="text-xl md:text-2xl font-heading text-secondary-600 mt-1">
              i Artykuły SEO
            </p>
          </div>
          <div className="lg:w-[33%] flex items-end">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              Najlepsze przewodniki{' '}
              <strong>Kakobuy Spreadsheet</strong> dla polskich użytkowników. Poznaj nasze artykuły i poradniki zakupowe.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {seoArticles.map((article, idx) => (
            <Link
              key={article.slug}
              to={`/artykul/${article.slug}/`}
              className={`rounded-2xl overflow-hidden group cursor-pointer ${
                idx === 0 ? 'bg-foreground-950' : 'bg-background-100'
              }`}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5 md:p-6">
                {idx === 0 && (
                  <span className="inline-block px-2 py-1 bg-accent-100/30 text-accent-300 text-xs font-medium rounded-full mb-3">
                    Polecane
                  </span>
                )}
                <h3
                  className={`text-base md:text-lg font-heading font-bold mb-2 ${
                    idx === 0 ? 'text-background-50' : 'text-foreground-950'
                  }`}
                >
                  {article.title}
                </h3>
                <p
                  className={`text-xs md:text-sm leading-relaxed ${
                    idx === 0 ? 'text-background-50/60' : 'text-foreground-600'
                  }`}
                >
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}